import {SvgIcon} from './SvgIcon'

export const GlobeIcon2: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#F7C839',
  strokeWidth = 1.5,
  fillColor = '#000000',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 18 19"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M14.4375 9.5C14.4375 12.503 12.003 14.9375 9 14.9375C5.99695 14.9375 3.5625 12.503 3.5625 9.5C3.5625 6.49695 5.99695 4.0625 9 4.0625C12.003 4.0625 14.4375 6.49695 14.4375 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4375 9.5C11.4375 12.875 9.93198 14.9375 9 14.9375C8.06802 14.9375 6.5625 12.875 6.5625 9.5C6.5625 6.125 8.06802 4.0625 9 4.0625C9.93198 4.0625 11.4375 6.125 11.4375 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 9.5H14.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const HealthIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#D4A0FF',
  fillColor = '#000000',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M3 5.17026C3 3.79907 4.11157 2.6875 5.48276 2.6875H12.5172C13.8884 2.6875 15 3.79907 15 5.17026V12.2047C15 13.5759 13.8884 14.6875 12.5172 14.6875H5.48276C4.11157 14.6875 3 13.5759 3 12.2047V5.17026Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0361 5.17188H7.96713V7.65463H5.48438V9.7236H7.96713V12.2064H10.0361V9.7236H12.5189V7.65463H10.0361V5.17188Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CreditCardIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#D750FB',
  strokeWidth = 1.5,
  fillColor = '#000000',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M3.5625 6.3125C3.5625 5.48407 4.23407 4.8125 5.0625 4.8125H12.9375C13.7659 4.8125 14.4375 5.48407 14.4375 6.3125V12.6875C14.4375 13.5159 13.7659 14.1875 12.9375 14.1875H5.0625C4.23407 14.1875 3.5625 13.5159 3.5625 12.6875V6.3125Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 8.1875H14.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8125 11.1875H7.6875"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8125 11.1875H12.1875"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PersonIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeWidth = 1.5,
  strokeColor = '#8A8DFC',
  fillColor = '#000000',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 18 19"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M11.4375 6.5C11.4375 7.84619 10.3462 8.9375 9 8.9375C7.65381 8.9375 6.5625 7.84619 6.5625 6.5C6.5625 5.15381 7.65381 4.0625 9 4.0625C10.3462 4.0625 11.4375 5.15381 11.4375 6.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.13445 14.9375H12.8632C13.7196 14.9375 14.3793 14.2011 13.9794 13.4438C13.3911 12.3298 12.0498 11 8.99882 11C5.94783 11 4.60657 12.3298 4.01825 13.4438C3.61829 14.2011 4.27801 14.9375 5.13445 14.9375Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UndoIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#AF50FF',
  strokeWidth = 1.5,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
  >
    <path
      d="M6.9375 3.5625L3.5625 6.75L6.9375 9.9375"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.125 6.75H11.4375C13.0944 6.75 14.4375 8.09315 14.4375 9.75V14.4375"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * todo:same icon is present in native.tsx but with different viewbox
 * need to check if we can update it
 */
export const ChevronIconBottom: SvgIcon = ({
  width = 18,
  height = 19,
  strokeColor = '#F7C839',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4375 8.5625L9 11.1875L6.5625 8.5625"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EyeIconLg: SvgIcon = ({
  width = 18,
  height = 19,
  strokeColor = '#F7C839',
  strokeWidth = 1.5,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8125 9.5C14.8125 10.25 13.4095 14.1875 9 14.1875C4.59052 14.1875 3.1875 10.25 3.1875 9.5C3.1875 8.75 4.59052 4.8125 9 4.8125C13.4095 4.8125 14.8125 8.75 14.8125 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6875 9.5C10.6875 10.432 9.93198 11.1875 9 11.1875C8.06802 11.1875 7.3125 10.432 7.3125 9.5C7.3125 8.56802 8.06802 7.8125 9 7.8125C9.93198 7.8125 10.6875 8.56802 10.6875 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FullArrowIcon: SvgIcon = ({
  width = 25,
  height = 25,
  strokeColor = 'text-dope-purple-50',
  strokeWidth = 1.5,
  classes,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M10.7227 7.25L5.22266 12.5L10.7227 17.75"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7227 12.5H5.47266"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ShieldIcon: SvgIcon = ({
  width = 19,
  height = 18,
  strokeColor = 'stroke-dope-red-200',
  fillColor = 'fill-dope-red-200',
  classes,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M9.4984 3.5625L4.0609 6C4.0609 6 3.4984 14.4375 9.4984 14.4375C15.4984 14.4375 14.9359 6 14.9359 6L9.4984 3.5625Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      className={`${strokeColor} stroke-current`}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 5.8125C9.91421 5.8125 10.25 6.23223 10.25 6.75V8.625C10.25 9.14277 9.91421 9.5625 9.5 9.5625C9.08579 9.5625 8.75 9.14277 8.75 8.625V6.75C8.75 6.23223 9.08579 5.8125 9.5 5.8125Z"
      className={`${fillColor} fill-current`}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.75 11.625C8.75 11.2108 9.08579 10.875 9.5 10.875C9.91421 10.875 10.25 11.2108 10.25 11.625C10.25 12.0392 9.91421 12.375 9.5 12.375C9.08579 12.375 8.75 12.0392 8.75 11.625Z"
      className={`${fillColor} fill-current`}
    />
  </svg>
)
